<div class="delete-popup-container">
  <div class="delete-popup-text">Are you sure you want to activate this <br>restaurant?</div>
  <div class="delete-popup-conform">
    <span mat-dialog-close mat-dialog-close="false">No</span>
    <span mat-dialog-close mat-dialog-close="true">Yes</span>
  </div>
</div>

<style>
  ::ng-deep .mat-dialog-container {
    padding: 0;
  }

  .delete-popup-container {
    width: 269px;
    border-radius: 6px;
    display: inline-block;
    background-color: rgba(253, 253, 253, 1);
    padding: 20px;
  }

  .delete-popup-text {
    color: rgba(28, 117, 188, 1);
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
  }

  .delete-popup-conform {
    float: right;
  }

  .delete-popup-conform span {
    color: rgba(57, 64, 70, 1);
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    margin-left: 25px;
    cursor: pointer;
  }
</style>